import moment from "moment";
import { DOC_STAGE, EMPTY_GUID, ORDER, SECTION_CD, TYPE_OF_DOC } from "../Config/Constants";
import axios from "axios";
import {
  getPdfSimpliBaseURL,
  getResumeBuildBaseURL,
  getSignSimpliBaseURL,
  getSsoLegalSimpliEndPoint,
} from "../Services/base-url/api-constants";
import UserService from "../Services/UserService";
import { getInitializationVector, isPaymentMSEnable,sasTokenExpiryHours,getBlobUri } from "./general-config";
import CryptoJS from "crypto-js";
import { BlobServiceClient } from '@azure/storage-blob';
import docOrchestrationServiceApi from "../Services/DocOrchService";
const currentEnv = `${process.env.REACT_APP_ENVIRONMENT}`;

export const readCookie = (name: string) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const createCookie = (name: string, value: string, days?: number, domain?: string) => {
  let expires = "";
  let _domain = "";
  if (days) {
    const date: any = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else expires = "";

  if (domain) {
    _domain = "; domain=" + domain;
  }
  document.cookie = name + "=" + value + expires + _domain + "; path=/;";
};

export const emptyDocument = (
  visitorGuid: string,
  templateType: string,
  templateNumber: string,
  templateCD: string,
  templateUrl: string,
  templateColor: string,
  userId: string,
  letterSize: string,
  state: any
) => {
  let path = templateType + "/" + templateCD.split("-")[0] + "/" + templateUrl;

  if (state) {
    path = "state-specific/" + templateType + `/${state}/` + templateCD.split("-")[0] + "/" + templateUrl;
  }
  const doc = {
    id: EMPTY_GUID,
    name: templateType,
    docStage: DOC_STAGE,
    createdOn: moment(new Date()),
    modifiedOn: moment(new Date()),
    tenantId: getTenantId(),
    userId: userId,
    visitorId: visitorGuid,
    typeOfDoc: TYPE_OF_DOC,
    paragraphs: [
      {
        id: EMPTY_GUID,
        docId: EMPTY_GUID,
        paraContents: [
          {
            id: EMPTY_GUID,
            paraId: EMPTY_GUID,
            content: JSON.stringify({}),
            order: ORDER,
            createdOn: moment(new Date()),
            modifiedOn: moment(new Date()),
          },
        ],
        order: ORDER,
        paraCD: templateType,
        sectionCD: SECTION_CD,
        paraName: templateType,
      },
    ],
    docStyle: {
      id: EMPTY_GUID,
      docId: EMPTY_GUID,
      fontFamily: null,
      fontSize: null,
      headingSize: null,
      themeColor: templateColor,
      letterSize: letterSize,
    },
    originalDocId: EMPTY_GUID,
    templateCD: templateCD + "-" + templateNumber,
    isDeleted: false,
    comment: null,
    isStarred: false,
    tags: null,
    shared: false,
    sharedEmail: [],
    renderPdfFileUrl: "",
    folderPath: null,
    locale: null,
    isParsedDoc: false,
    originalURL: path,
  };

  return doc;
};

export const createParagraph = (
  paragraphId: string,
  docGuid: string,
  paraContent: string,
  orderNo: number,
  templateType: string,
  contentId: string
) => {
  const para = {
    id: paragraphId,
    docId: docGuid,
    paraContents: [
      {
        id: contentId,
        paraId: paragraphId,
        content: paraContent,
        order: orderNo,
        createdOn: moment(new Date()),
        modifiedOn: moment(new Date()),
      },
    ],
    order: orderNo,
    paraCD: templateType,
    sectionCD: SECTION_CD,
    paraName: templateType,
  };
  return para;
};

export const getDocIds = async () => {
  const getDocIds = localStorage.getItem("saveDocIds");
  let toParse = null;
  if (getDocIds) {
    toParse = JSON.parse(getDocIds);
  }
  const storeValue = toParse;
  return storeValue;
};

// TO DO :: Check the previous key and delete it on intial and last step
export const DeleteTemplateDocId = async (templateType: string, isInitialStep: boolean) => {
  const getDocId = await getDocIds();
  let storeValue: any = {};
  if (isInitialStep === true) {
    deleteCookie("docid");
  }
  if (getDocId) {
    if (getDocId.hasOwnProperty(templateType)) {
      delete getDocId[templateType];
    }
    storeValue = getDocId;
  }
  localStorage.setItem("saveDocIds", JSON.stringify(storeValue));
};

export const GetTemplateDocId = async (templateType: string) => {
  const getDocId = await getDocIds();
  if (getDocId) {
    if (getDocId.hasOwnProperty(templateType)) {
      return getDocId[templateType];
    }
  }
};

export const saveDocIds = async (templateType: string, docId: string) => {
  const getDocId = await getDocIds();
  let storeValue: any = {};
  if (getDocId) {
    storeValue = getDocId;
  }
  storeValue[templateType] = docId;
  localStorage.setItem("saveDocIds", JSON.stringify(storeValue));
};

export const filterParagraph = (para: any) => {
  let paraId = "";
  let content = "";
  para.forEach((element: any) => {
    if (element.id !== EMPTY_GUID) {
      paraId = element.id;
    }

    if (element.paraContents[0].id !== EMPTY_GUID) {
      content = JSON.parse(element.paraContents[0].content);
    }
  });

  return { paraId, content };
};
export const getPortalCD = () => {
  return "LSEN";
};
export const getTenantId = () => {
  const tenantId: any = {
    QA: "A21468BD-04E0-4131-9DC7-54B61FEE0670",
    PRODUCTION: "0F10199F-52CD-488D-B949-F3DCBD34070F",
    STAGING: "0F10199F-52CD-488D-B949-F3DCBD34070F",
    DEVELOPMENT: "A21468BD-04E0-4131-9DC7-54B61FEE0670",
  };
  return tenantId[currentEnv];
};
export const getServiceCodeForgotPwd = () => {
  return "SRVRGR";
};
export const proIPKey = () => {
  return "qGpUO64dv9znGra";
};
export const getIPConfig = async () => {
  const res = await axios.get(
    "https://pro.ip-api.com/json?key=" +
      proIPKey() +
      "&fields=country,countryCode,status,query,currency,region,zip,city"
  );
  if (!!res.data && res.data.zip == "" && res.data.countryCode == "US") {
    UserService.getIp2Connect(res.data.query).then((response) => {
      if (!!response.data) {
        res.data.zip = response.data;
        localStorage.setItem("ipconfig", JSON.stringify(res.data));
      }
    });
  } else {
    localStorage.setItem("ipconfig", JSON.stringify(res.data));
  }
};
export const setIPConfig = (param: any, defaultValue?: string) => {
  if (localStorage.getItem("ipconfig") !== null) {
    const ipconfig = localStorage.getItem("ipconfig") || "{}";
    const ipConfigData = JSON.parse(ipconfig);
    return ipConfigData[param];
  } else {
    return defaultValue;
  }
};
export const loadScript = (url: string) => {
  const script = document.createElement("script");
  script.src = url;
  document.head.appendChild(script);
};
export const removeScript = (url: string) => {
  var scripts = document.getElementsByTagName("script");
  for (let script of scripts as any) {
    if (script.src === window.location.origin + url) {
      script.remove();
      break;
    }
  }
};
export const deleteCookie = (name: string) => {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};
export const deletedomainCookie = (name: string) => {
  document.cookie = name + "=; domain=.resumebuild.com; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};
export const gotToDashBoardWithLocale = (locale: string) => {
  let localeval = "";
  if (!!locale) {
    localeval = locale + "/";
  }
  return getSsoLegalSimpliEndPoint + localeval;
};

export const goToPdfSimpli = (locale: string) => {
  return getPdfSimpliBaseURL + (!locale ? "" : "/" + locale);
};
export const goToSignSimpli = (locale: string) => {
  return getSignSimpliBaseURL + (!locale ? "" : "/" + locale);
};
export const goToResumeBuild = (locale: string) => {
  return getResumeBuildBaseURL + "/app" + (!!locale && locale != "en" ? "/" + locale : "");
};

const DecryptedString = (encryptedText: any, key: any) => {
  const iv = getInitializationVector();
  const bytes = CryptoJS.AES.decrypt(encryptedText, CryptoJS.enc.Utf8.parse(key), {
    iv: CryptoJS.enc.Utf8.parse(iv),
  });
  const decrypted = bytes.toString(CryptoJS.enc.Utf8);
  console.log(decrypted);
  return decrypted;
};

export const PerquisiteBountyEnable = (chiperText: any, userGuid: any) => {
  const decryptVal = DecryptedString(chiperText, userGuid.replaceAll("-", ""));
  return decryptVal?.toLowerCase() === "true" ? true : false;
};

export const redirectToPMSAndExistPlanPage = () => {
  let isNavigateToExistingPlanPage = false;
  let ispmsEnable = readCookie("pms");
  if ((!!ispmsEnable && ispmsEnable === "true") || isPaymentMSEnable() === true) {
    console.log("to PMS page1..");
    window.location.assign("/app/billing/?useExternalTemplate=true");
  } else {
    isNavigateToExistingPlanPage = true;
  }
  return isNavigateToExistingPlanPage;
};
export const generateSasUriToken = async () => {
  return docOrchestrationServiceApi
    .GenerateSasUriTokenForContainer(sasTokenExpiryHours)
    .then((response) => {
      if (!!response && response?.data) {
        const token = new URL(response.data);
        return token.search;
      } else {
        const urlString =
          typeof response.data === "string" ? response.data : typeof response === "string" ? response : null;
        if (urlString) {
          const url = new URL(urlString);
          return url.search;
        } else {
          return "?sv=2025-01-05&st=2025-08-31T12%3A30%3A50Z&se=2025-09-02T13%3A30%3A50Z&sr=c&sp=rw&sig=66FET9hqcSysSBpwfdVOJn3MDOs9B%2FTGLKjq4HtR28o%3D&api-version=2018-03-28";
        }
      }
    })
    .catch((error) => {
      return "?sv=2025-01-05&st=2025-08-31T12%3A30%3A50Z&se=2025-09-02T13%3A30%3A50Z&sr=c&sp=rw&sig=66FET9hqcSysSBpwfdVOJn3MDOs9B%2FTGLKjq4HtR28o%3D&api-version=2018-03-28";
    });
};
export const UploadHtmlToBlob = async (userGuid: string, docId: string, htmlContent: any, documentName: string) => {
  try {
    if (!userGuid || !docId) {
      throw new Error("userGuid or docId is missing");
    }
     // format date as _yyyymmdd
    // const now = new Date();
    // const yyyy = now.getFullYear();
    // const mm = String(now.getMonth() + 1).padStart(2, "0");
    // const dd = String(now.getDate()).padStart(2, "0");
    // const formattedDate = `_${yyyy}${mm}${dd}`;

    const BlobUrl = getBlobUri();
    const containerName = "pdfsimpliusers";
    const BlobSignature = readCookie("signatureToken") || await generateSasUriToken();
    if(readCookie("signatureToken")===null){
      createCookie("signatureToken", BlobSignature, 1);
    }
    // const blobName = `${userGuid.replace(/-/g, "")}/${docId}_${documentName.replaceAll("/", "_")}${formattedDate}.html`;
    const blobName = `${userGuid.replace(/-/g, "")}/${docId}_${documentName.replaceAll("/", "_")}.html`;
    const blobServiceClient = new BlobServiceClient(`${BlobUrl}${BlobSignature}`);
    const containerClient = blobServiceClient.getContainerClient(containerName);
    const blockBlobClient = containerClient.getBlockBlobClient(blobName);
    const blob = new Blob([htmlContent], { type: "text/html" });
    await blockBlobClient.uploadData(blob, {
      blobHTTPHeaders: {
        blobContentType: "text/html",
      },
    });
  } catch (error) {
    console.error("Upload failed:", error);
  }
}; 
export const navigateToSignleLoginAPP = (locale: any, NavigateToSignUp: boolean, queryParam: string) => {
  let actionPage = "/signin";
  if (NavigateToSignUp === true) {
    actionPage = "/signup";
  }
  let redirectionURL = !!locale && locale !== "en" ? `/app/${locale}/account/signup` : "/app/account" + actionPage;
  // window.location.assign(redirectionURL);
  if (`${process.env.REACT_APP_ENVIRONMENT}` == "DEVELOPMENT") {
    window.location.href = "https://localhost:5000/app" + (!locale ? "" : "/" + locale) + "/account" + actionPage;
  } else {
    window.location.assign(redirectionURL + queryParam);
  }
};